import request from '@/utils/request'


// 查询用户计划关联列表
export function listPlanRecord(query) {
  return request({
    url: '/user/planRecord/list',
    method: 'get',
    params: query
  })
}

// 查询用户计划关联分页
export function pagePlanRecord(query) {
  return request({
    url: '/user/planRecord/page',
    method: 'get',
    params: query
  })
}

// 查询用户计划关联详细
export function getPlanRecord(data) {
  return request({
    url: '/user/planRecord/detail',
    method: 'get',
    params: data
  })
}

// 新增用户计划关联
export function addPlanRecord(data) {
  return request({
    url: '/user/planRecord/add',
    method: 'post',
    data: data
  })
}

// 修改用户计划关联
export function updatePlanRecord(data) {
  return request({
    url: '/user/planRecord/edit',
    method: 'post',
    data: data
  })
}

// 删除用户计划关联
export function delPlanRecord(data) {
  return request({
    url: '/user/planRecord/delete',
    method: 'post',
    data: data
  })
}
